import React, { useState, useEffect } from "react";
import "./index.scss";
import CustomModal from "../../core/modal";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import { getHeaderConfig } from "./config";
import { invokeApi, HTTP_METHODS } from "../../utils/http-service";
import { HOSTNAME, REST_URLS } from "../../utils/endpoints";
import { useNavigate } from "react-router-dom";
import { getOfflineData } from "../../utils/offline-services";
import Box from "@mui/material/Box";
import SiTable from "../../core/table";
import { toast } from "react-toastify";
import { Add, ArrowForward } from "@mui/icons-material";
import CustomButtonComponent from "../../core/custom-button";
import CustomTable from "../../core/custom-table";
const MailingList = () => {
  const [emails, setEmails] = useState([]);
  const navigate = useNavigate();
  const [addEmail, setAddEmail] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  useEffect(() => {
    if (!getOfflineData("user")) {
      navigate("/");
    } else {
      loadData();
    }
  }, []);
  const emailHandler = (event) => {
    setAddEmail(event.target.value);
  };
  const payload = {
    email: addEmail,
  };
  //load email Ids
  const loadData = () => {
    invokeApi(
      HTTP_METHODS.GET,
      `${HOSTNAME}${REST_URLS.MAILING_LIST}/list-emails`,
      null
    )
      .then((response) => {
        if (response) {
          setEmails(response);
        }
      })
      .catch((err) => console.error(err));
  };
  //Add Email
  const formSubmitHandler = () => {
    if (addEmail !== "") {
      invokeApi(
        HTTP_METHODS.POST,
        `${HOSTNAME}${REST_URLS.MAILING_LIST}/add-email`,
        payload,
        { active: true }
      )
        .then((response) => {
          if (response.message) {
            toast.error(response.message);
          } else {
            loadData();
            setAddEmail("");
            setIsModalOpen(false);
          }
        })
        .catch((err) => console.error(err));
    }
  };
  return (
    <div className="page-body">
      <div className="create-con">
        <div>
          <p className="tab-name">Setup</p>
          <p className="section-name">Mailing List</p>
        </div>
        <CustomButtonComponent
          variant="contained"
          color="primary"
          onClick={() => setIsModalOpen(true)}
        >
          Add Mail
        </CustomButtonComponent>
      </div>

      <div className="si-hide-mobile">
        <CustomTable header={getHeaderConfig(loadData)} data={emails || []} />
      </div>
      {isModalOpen && (
        <CustomModal title="Add New Mail" onClose={() => setIsModalOpen(false)}>
          <Box
            sx={{
              width: 500,
              maxWidth: "100%",
            }}
          >
            <TextField
              fullWidth
              id="email"
              label="Email"
              sx={{ m: 1 }}
              onChange={emailHandler}
              value={addEmail}
              type="email"
              size="small"
            />
            <Stack direction="row" spacing={2} sx={{ mt: 3 }}>
              <CustomButtonComponent
                variant="outlined"
                fullWidth
                color="error"
                onClick={() => {
                  setIsModalOpen(false);
                }}
              >
                Cancel
              </CustomButtonComponent>
              <CustomButtonComponent
                variant="contained"
                color="primary"
                fullWidth
                onClick={formSubmitHandler}
              >
                Save
              </CustomButtonComponent>
            </Stack>
          </Box>
        </CustomModal>
      )}
    </div>
  );
};

export default MailingList;
